module.exports = __webpack_public_path__ + "static/media/vice-captain.svg.cfd0a58c.png";